export interface Font {
  key: string;
  title: string;
}

export const fonts: Array<Font> = [
  {key: 'Microsoft YaHei', title: '微软雅黑'},
  {key: 'STFangsong', title: '华文仿宋'},
  {key: 'Comic Sans MS', title: 'Comic Sans MS'},
  {key: 'Arial', title: 'Arial'},
  {key: 'Courier New', title: 'Courier New'},
  {key: 'Verdana', title: 'Verdana'}
]